<sbnb-confetti #confetti></sbnb-confetti>
<sbnb-loading-spinner *ngIf="loading$ | async"></sbnb-loading-spinner>

<form [formGroup]="integrationForm" *ngIf="formInitialized$ | async">
  <ng-container *ngIf="editing">
    <mat-tab-group>
      <mat-tab label="Chart of Accounts">
        <sbnb-statements-accounting-connection-form-map-accounts
          formGroupName="accounts"></sbnb-statements-accounting-connection-form-map-accounts>
      </mat-tab>
      <mat-tab label="Properties" *ngIf="formInitialized$ | async">
        <sbnb-statements-accounting-connection-form-tracking-categories
          formGroupName="properties"></sbnb-statements-accounting-connection-form-tracking-categories>
      </mat-tab>
      <mat-tab label="Owners">
        <sbnb-statements-accounting-connection-form-owners
          *ngIf="eligibleOwners$ | async as eligibleOwners"
          formGroupName="owners"
          [eligibleOwners]="eligibleOwners"></sbnb-statements-accounting-connection-form-owners>
      </mat-tab>
    </mat-tab-group>
    <div class="flex justify-between mt-6" *ngIf="(loading$ | async) !== true && formInitialized$ | async">
      <!-- Delete connection button -->
      <sbnb-button
        [disabled]="editing"
        [matTooltip]="editing ? 'Existing connections cannot be deleted.' : null"
        label="Delete connection"
        icon="trash"
        [loading]="(deleting$ | async)?.inProgress"
        loadingLabel="Deleting..."
        (click)="deleteConnectionPrompt()"></sbnb-button>
      <!-- Save button -->
      <div class="flex justify-end gap-2">
        <sbnb-button label="Preview" type="secondary" (click)="openPreviewDialog()"></sbnb-button>
        <sbnb-button label="Save" (click)="save()" [loading]="saving$ | async" loadingLabel="Saving..."></sbnb-button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!editing">
    <sbnb-progress-stepper [selectedIndex]="currentStep">
      <cdk-step label="Chart of Accounts" [completed]="currentStep > 0">
        <div class="mt-8">
          <sbnb-statements-accounting-connection-form-map-accounts
            formGroupName="accounts"></sbnb-statements-accounting-connection-form-map-accounts>
          <div class="flex flex-row justify-between mt-6">
            <sbnb-button label="Cancel" type="secondary" (click)="redirectToAccounting()"></sbnb-button>
            <div class="flex justify-end gap-2">
              <sbnb-button
                label="Preview"
                [type]="(hasPreviewed | async) ? 'secondary' : 'primary'"
                (click)="openPreviewDialog()"></sbnb-button>
              <sbnb-button
                label="Next: Select your properties"
                type="primary"
                [disabled]="(hasPreviewed | async) !== true"
                matTooltip="Preview the mapping before continuing."
                (click)="next()"></sbnb-button>
            </div>
          </div>
        </div>
      </cdk-step>
      <cdk-step label="Properties" [completed]="currentStep > 1">
        <div class="mt-8">
          <sbnb-statements-accounting-connection-form-tracking-categories
            formGroupName="properties"></sbnb-statements-accounting-connection-form-tracking-categories>
          <div class="flex justify-between mt-6">
            <sbnb-button label="Back" type="secondary" (click)="back()"></sbnb-button>
            <div class="flex justify-end gap-2">
              <sbnb-button label="Preview" type="secondary" (click)="openPreviewDialog()"></sbnb-button>
              <sbnb-button label="Next" type="primary" (click)="next()"></sbnb-button>
            </div>
          </div>
        </div>
      </cdk-step>
      <cdk-step label="Owners" [completed]="currentStep > 2">
        <div class="mt-8">
          <sbnb-statements-accounting-connection-form-owners
            *ngIf="eligibleOwners$ | async as eligibleOwners"
            formGroupName="owners"
            [eligibleOwners]="eligibleOwners"></sbnb-statements-accounting-connection-form-owners>
          <div class="flex justify-between mt-6">
            <sbnb-button label="Back" type="secondary" (click)="back()"></sbnb-button>
            <sbnb-button label="Connect" type="primary" (click)="next(); save()"></sbnb-button>
          </div>
        </div>
      </cdk-step>
      <cdk-step label="Connect" [completed]="currentStep > 3">
        <div class="mt-12 h-[500px] max-h-[80vh]">
          <div *ngIf="saving$ | async" class="flex flex-col justify-center items-center w-full h-full">
            <h2 class="text-center">Configuring your Quickbooks account...</h2>
            <sbnb-loading-spinner></sbnb-loading-spinner>
          </div>
          <div
            *ngIf="(connectionError$ | async) && (saving$ | async) !== true"
            class="flex flex-col justify-center items-center w-full h-full gap-4">
            <h2 class="max-w-[500px] text-center">Oops, there was an error connecting to your Quickbooks account.</h2>

            <sbnb-button label="Try again" type="primary" (click)="save()"></sbnb-button>
          </div>
          <div
            class="flex flex-col justify-center items-center w-full h-full"
            *ngIf="(saving$ | async) === false && (connectionError$ | async) === null">
            <h2>Configuration successful!</h2>
            <sbnb-icon icon="check" [size]="148" class="text-grass-darker"></sbnb-icon>
            <div class="flex justify-end mt-6"></div>
            <sbnb-button label="Go to Accounting" type="primary" (click)="redirectToAccounting()"></sbnb-button>
          </div>
        </div>
      </cdk-step>
    </sbnb-progress-stepper>
  </ng-container>
</form>
